import React, { useState } from 'react';
import BadgeIcon from './BadgeIcon';
import BadgeInfoPopup from './BadgeInfoPopup';
import { BadgeType, BadgeTier, getBadgeTier } from '../utils/badges';
import { sound } from '../utils/sound';

interface NewBadge {
  type: BadgeType;
  tier: BadgeTier;
}

interface BadgeSlotsProps {
  animateBadges?: NewBadge[];
}

const BadgeSlots: React.FC<BadgeSlotsProps> = ({ animateBadges = [] }) => {
  const streakTier = getBadgeTier(BadgeType.STREAK);
  const completionTier = getBadgeTier(BadgeType.COMPLETION);
  const geniusTier = getBadgeTier(BadgeType.GENIUS);

  const [showBadgePopup, setShowBadgePopup] = useState(false);

  // Check if a badge should animate
  const shouldAnimate = (type: BadgeType, tier: BadgeTier): boolean => {
    return animateBadges.some(badge => badge.type === type && badge.tier === tier);
  };

  const handleBadgeClick = () => {
    sound.clickOpen();
    setShowBadgePopup(true);
  };

  const handleClosePopup = () => {
    setShowBadgePopup(false);
  };

  return (
    <>
      <div className="badge-slots" onClick={handleBadgeClick}>
        <div className="badge-slot-container">
          <BadgeIcon
            type={BadgeType.STREAK}
            tier={streakTier}
            size="small"
            animate={shouldAnimate(BadgeType.STREAK, streakTier)}
          />
        </div>
        <div className="badge-slot-container">
          <BadgeIcon
            type={BadgeType.COMPLETION}
            tier={completionTier}
            size="small"
            animate={shouldAnimate(BadgeType.COMPLETION, completionTier)}
          />
        </div>
        <div className="badge-slot-container">
          <BadgeIcon
            type={BadgeType.GENIUS}
            tier={geniusTier}
            size="small"
            animate={shouldAnimate(BadgeType.GENIUS, geniusTier)}
          />
        </div>
      </div>
      {showBadgePopup && (
        <BadgeInfoPopup onClose={handleClosePopup} />
      )}
    </>
  );
};

export default BadgeSlots;
